window.OKJS = window.OKJS || {};
(function (OKJS) {
    OKJS.Search = {
        init: function () {

        },

        setupButton: function (selector, scriptHtml) {
            var btn = document.querySelectorAll(selector);

            var hasClicked = false;

            for (var i = 0; i < btn.length; i++) {
                OKJS.Global.addOnceEventListener(btn[i], 'click', function (e) {
                    if (hasClicked) {
                        return;
                    }
                    hasClicked = true;

                    for (var j = 0; j < btn.length; j++) {
                        btn[j].classList.add('loading');
                    }

                    OKJS.Global.injectScriptHtml(scriptHtml);
                });
            }
        }
    };
}(window.OKJS));
